import { b } from './chunk-26IU2X5T.mjs';
import { a } from './chunk-MRVWIDD7.mjs';
import { Root, Trigger, Portal, Content, Item, Sub, Separator, Label, Arrow, SubTrigger, SubContent } from '@radix-ui/react-dropdown-menu';
import r, { css } from 'styled-components';

var A={};a(A,{Arrow:()=>C,Content:()=>S,Description:()=>R,Item:()=>k,ItemLabel:()=>L,Label:()=>z,Portal:()=>P,RightSlot:()=>I,Root:()=>x,Separator:()=>y,Sub:()=>w,SubContent:()=>$,SubTrigger:()=>T,Trigger:()=>h});var e=css`
  max-width: 320px;
  box-shadow: var(--elevation-300);
  background: var(--background-level-3);
  border-radius: var(--border-radius-small);
  padding: var(--spacing-small) var(--spacing-x-small);
`,t=css`
  display: flex;
  gap: var(--spacing-small);
  padding: var(--spacing-small) var(--spacing-regular);
  margin-bottom: var(--spacing-x-small);
  color: var(--foreground-primary);
  font-size: var(--font-size-regular);
  user-select: none;
  text-decoration: none;
  cursor: pointer;

  ${b} {
    color: var(--foreground-secondary);
  }

  :focus {
    outline: var(--border-width-small) solid var(--border-link-focus);
    border-radius: var(--border-radius-small);
  }

  :hover:not(&[data-disabled]) {
    background-color: var(--background-selected);
    border-radius: var(--border-radius-small);
    outline: none;
  }

  &[data-disabled] {
    pointer-events: none;
    color: var(--foreground-disabled);
    ${b} {
      color: var(--foreground-disabled);
    }
  }
`,x=r(Root).attrs(i=>({modal:!1,...i}))``,h=r(Trigger)`
  align-items: center;

  &[data-state='open'] {
    background: var(--background-button-secondary-active);
    color: var(--foreground-button-secondary-hover);
    border: 4px solid var(--background-button-destructive-disabled);
  }
`,P=r(Portal)``,S=r(Content).attrs({sideOffset:4})`
  ${e}
`,k=r(Item)`
  ${t}
`,w=r(Sub)`
  padding: var(--spacing-small) var(--spacing-regular);
`,y=r(Separator)`
  height: 1px;
  background-color: var(--border-default);
  margin: var(--spacing-x-small);
`,z=r(Label)`
  color: var(--foreground-tertiary);
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-bold);
  text-transform: uppercase;
  letter-spacing: var(--letter-spacing-spacious);
  padding: var(--spacing-small) var(--spacing-regular);
`,C=r(Arrow)`
  fill: white;
`,T=r(SubTrigger)`
  ${t}
`,$=r(SubContent).attrs({sideOffset:4})`
  ${e}
`,I=r.div`
  margin-left: auto;
  padding-left: var(--spacing-regular);
`,L=r.div``,R=r.div`
  color: var(--foreground-secondary);
  font-size: var(--font-size-small);
  line-height: var(--line-height-large);
`;

export { x as a, h as b, P as c, S as d, k as e, w as f, y as g, z as h, C as i, T as j, $ as k, I as l, L as m, R as n, A as o };
